import { SimpleGrid, Stack, Text, Title } from 'components'
import { useArcTranslation } from 'hooks'
import { useManagerDashboard } from '../context/ManagerDashboardContext'
import { ClassMiniCard } from './ClassMiniCard'
import { GridSkeleton } from './GridSkeleton'
import { GRID_BREAKPOINTS, GRID_COLS } from '../constants'

/** "Latest created classes" section. */
export const LatestClassesSection = () => {
  const { t } = useArcTranslation()
  const { classes, classesLoading, classesError } = useManagerDashboard()

  const renderBody = () => {
    if (classesLoading) return <GridSkeleton />
    if (classesError) {
      return (
        <Text color='dimmed' size='sm' role='alert'>
          {t('manager_dashboard.classes_error')}
        </Text>
      )
    }
    if (classes.length === 0) {
      return (
        <Text color='dimmed' size='sm'>
          {t('manager_dashboard.empty_classes')}
        </Text>
      )
    }
    return (
      <SimpleGrid cols={GRID_COLS} spacing='md' breakpoints={GRID_BREAKPOINTS}>
        {classes.map(managerClass => (
          <ClassMiniCard key={managerClass.id} managerClass={managerClass} />
        ))}
      </SimpleGrid>
    )
  }

  return (
    <Stack spacing='sm'>
      <Title order={2} size='h4'>
        {t('manager_dashboard.latest_classes_title')}
      </Title>
      {renderBody()}
    </Stack>
  )
}
